import React from 'react';

import Select from 'react-select';

import companyType from '@/data/companyType';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectCompanyType: React.FC<any> = ({ name, value, defaultValue, placeholder, handleChange, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={companyType.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={companyType}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectCompanyType;

{/* <SelectComponent
    name="companyType"
    value={selectedCompanyType}
    options={companyType}
    defaultValue={defaultCompanyType}
    placeholder="Select a company type"
    handleChange={handleCompanyTypeChange}
    hasError={formError} // Ensure this is a boolean
    isDisabled={isLoading} // Ensure this is a boolean
/> */}
